import { StyledIconAzure } from './IconAzure.styled';

const IconAzure = () => {
  return <StyledIconAzure />;
};

export default IconAzure;
